import Tooltip from '@mui/material/Tooltip'

interface IProps {
  label: string
  message: string
}

export const WarningHint = ({ label, message }: IProps) => (
  <Tooltip title={message} arrow placement='top' describeChild>
    <span
      role='img'
      aria-label={label}
      tabIndex={0}
      className='d-inline-flex flex-shrink-0'
      style={{ cursor: 'help' }}
    >
      <i className='bi bi-exclamation-triangle-fill text-warning fs-5' />
    </span>
  </Tooltip>
)
